import { useTranslation } from 'react-i18next';

import { GlassCardLabel, GlassCard } from '@app/shared/ui/atoms/Home';
import { homeMoonImage } from '@app/assets';

export function DailyEnergyCard() {
  const { t } = useTranslation();

  return (
    <GlassCard className="flex min-w-[72px] flex-col items-center pb-0.5">
      <img src={homeMoonImage} alt="moon" className="-mb-3 w-[66px]" />
      <GlassCardLabel>{t('home.energy')}</GlassCardLabel>
    </GlassCard>
  );
}
